import {mParticleEventType, mParticleLogEvent} from '@treatwell/ui';
import {SDKEventAttrs} from '@mparticle/web-sdk';

export const trackEvent = ({
  eventName,
  eventType,
  eventAttributes,
}: {
  eventName: string;
  eventType?: (typeof mParticleEventType)[keyof typeof mParticleEventType];
  eventAttributes: SDKEventAttrs;
}) => {
  mParticleLogEvent(
    eventName,
    eventType ? eventType : mParticleEventType.Other,
    eventAttributes
  );
};
